class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    if (!this.mainDetailsToggle) {
      return;
    }

    this.addEventListener('keyup', onKeyUpEscape);
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    if (this.mainDetailsToggle) {
       this.mainDetailsToggle.removeAttribute('open')
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
